export class EmailSignaturePreviewApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getEmailSignaturePreview({ companyId }) {
    return this.#http.get(`/email-signature-templates/${companyId}/preview`);
  }

  async getApplicationSignaturePreview({ applicationId }) {
    return this.#http.get(`/email-signature-templates/${applicationId}/signature`);
  }
}
